import axios from 'axios'
import { Auth } from 'aws-amplify'
import { newRequestKey } from './billing'

const uploads = new WeakMap()
export function resourcesChanged() {
  window.dispatchEvent(new Event('billing:changed'))
  try { localStorage.setItem('billing-updated', String(Date.now())) } catch (_) { /* Optional cross-tab refresh. */ }
}
export function showResourceError(error) {
  const data = (error.response && error.response.data) || error
  const code = data.error || data.code
  window.dispatchEvent(new CustomEvent('resources:notice', {
    detail: {
      kind: ({ STORAGE_LIMIT_EXCEEDED: 'storage', INSUFFICIENT_CREDITS: 'ai' })[code] || 'error',
      message: data.message || 'The operation could not be completed. Please try again.',
    },
  }))
}
export async function uploadMedia(data, source, config = {}) {
  let state = uploads.get(source)
  if (!state) { state = { key: newRequestKey() }; uploads.set(source, state) }
  if (state.result) return state.result
  if (state.pending) return state.pending
  state.pending = (async () => {
    try {
      const session = await Auth.currentSession()
      const response = await axios.post('https://content.selfbiography.com/api/upload', data, {
        ...config,
        timeout: 180000,
        headers: { Authorization: session.getAccessToken().getJwtToken(), 'Idempotency-Key': state.key },
      })
      if (!response.data || response.data.error || !response.data.Data || !response.data.Data.Key) throw new Error('Upload was not confirmed. Please try again.')
      state.result = response
      resourcesChanged()

      return response
    } catch (error) {
      const code = error.response && error.response.data && error.response.data.error
      if (['UPLOAD_FINISHED', 'UPLOAD_KEY_REUSED'].includes(code)) uploads.delete(source)
      showResourceError(error)
      throw error
    } finally { state.pending = null }
  })()

  return state.pending
}
